import { spacing } from './types'
import type { SpacingSize } from './types'
import type { CSSProperties, ReactNode } from 'react'

export interface RowProps {
  gap?: SpacingSize
  /** Default: 'center' */
  align?: CSSProperties['alignItems']
  justify?: CSSProperties['justifyContent']
  wrap?: boolean
  style?: CSSProperties
  className?: string
  children?: ReactNode
}

/** Horizontal flex row, vertically centered by default. Use instead of inline `display:flex, alignItems:center`.
 *  Pass a named gap constant (e.g. gap="sm") — see SpacingSize for the full scale. */
export function Row({
  gap,
  align = 'center',
  justify,
  wrap,
  style,
  className,
  children,
}: RowProps) {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        alignItems: align,
        justifyContent: justify,
        gap: gap ? spacing[gap] : undefined,
        flexWrap: wrap ? 'wrap' : undefined,
        ...style,
      }}
    >
      {children}
    </div>
  )
}
